import type { BaseEntity } from '@/types/entities';

import { GridCell } from './GridCell';
import type { GridCellRef, GridColumn } from './types';

export interface GridBodyProps<T extends BaseEntity> {
  /** Sichtbare Spalten in Anzeigereihenfolge. */
  columns: GridColumn<T>[];
  rows: T[];
  selected: GridCellRef | null;
  editing: GridCellRef | null;
  onSelect: (rowId: number, field: string) => void;
  onStartEdit: (rowId: number, field: string) => void;
  onStopEdit: () => void;
  onCellSave: (item: T, columnName: string) => void;
}

export function GridBody<T extends BaseEntity>(props: GridBodyProps<T>) {
  const { columns, editing, onCellSave, onSelect, onStartEdit, onStopEdit, selected } = props;

  return (
    <>
      {props.rows.map((row, index) => (
        // Die alternierende Zeilenfärbung entfällt (REQ-21 §4): Im Entwurf trägt die
        // Trennlinie unter der Zeile die Struktur, nicht der Zebrastreifen.
        <tr key={row.Id} role="row" className="e-row" aria-rowindex={index + 1}>
          {columns.map((column) => (
            <GridCell
              key={column.field}
              row={row}
              column={column}
              selected={selected?.rowId === row.Id && selected.field === column.field}
              editing={editing?.rowId === row.Id && editing.field === column.field}
              onSelect={() => {
                onSelect(row.Id, column.field);
              }}
              onStartEdit={() => {
                onStartEdit(row.Id, column.field);
              }}
              onStopEdit={onStopEdit}
              onCellSave={onCellSave}
            />
          ))}
        </tr>
      ))}
    </>
  );
}

export default GridBody;
